import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
    dsn: 'https://7a57c60e71d84b868d28fda8278fe513@ext.sentry.doctis.tech/11',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
});
